import connect from './connect'
import ClientShowPage from './ClientShowPage'

export default connect(ClientShowPage)
